export default __webpack_public_path__ + "f111eee069eb53caca78b7eff2d6b4e2.svg";